// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1wYGc","label":"Radio_label__KA56G","checkMark":"Radio_checkMark__2ZYho","disabled":"Radio_disabled__1lLKD"};